module.exports = __webpack_public_path__ + "img/edit-pencil-white.9a548fbe.svg";